import { useState, useContext, useEffect, useMemo } from "react";
import { read, utils } from "xlsx";
import { format } from 'date-fns';
import { HadeethContext } from "../../contexts/hadeethContext";
import { HadeethCard } from "./HadeethCard";

export const Testimonials = () => {
  const { data, loading } = useContext(HadeethContext);
  const hadeeth = !loading && data && data.allHadeeth;

  const [todaysHadeeth, setTodaysHadeeth] = useState(null);
  const today = useMemo(() => format(new Date(), 'M/d/yy'), []);

  useEffect(() => {
    if (hadeeth && hadeeth.length > 0) {
      const result = hadeeth[0];
      const url = result.excel_file.asset.url;

      const req = new XMLHttpRequest();
      req.open("GET", url, true);
      req.responseType = "arraybuffer";

      req.onload = function () {
        const data = new Uint8Array(req.response);
        const wb = read(data, { type: "array" });
        const ws = wb.Sheets["Sheet1"];
        const datas = utils.sheet_to_json(ws, { raw: false });
        const found = datas.find((obj) => obj.Date === today);
        setTodaysHadeeth(found);
      };
      req.send();
    }
  }, [hadeeth, today]);

  return (
    <div id="testimonials">
      <span className="testimonialsAnchor" id="testimonialsAnchor" aria-hidden="true"></span>
      <div className="container">
        <div className="section-title text-center">
          <h2>Daily Hadeeth</h2>
        </div>
        <div className="row">
          <div className="col-md-12">
            <HadeethCard hadeeth={todaysHadeeth} />
          </div>
        </div>
      </div>
    </div>
  );
};
